var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.className,attrs:{"to":{ name: 'home-tag', params: { tag: _vm.name } }}},[_vm._v("\n  "+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }